import { FirestoreDataConverter } from "firebase/firestore";
import { map } from "lodash";
import moment from "moment";
import Declaracao, { RelatorioRendaVariavel } from "../models/declaracao";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class DeclaracaoDb extends BaseDb<
  Declaracao,
  { usuarioId: string; declaracaoId: string }
> {
  _path: string = "usuarios/usuarioId/declaracoes/declaracaoId";
  getConverter(): FirestoreDataConverter<Declaracao> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Declaracao({
          criadoEm: moment(snapshot.get("criadoEm").toDate()),
          dataBase: moment(snapshot.get("dataBase").toDate()),
          relatorio1: snapshot.get("relatorio1"),
          relatorio2: snapshot.get("relatorio2"),
          relatorio3: snapshot.get("relatorio3"),
          relatorio4: snapshot.get("relatorio4"),
          relatorio5: {
            ...snapshot.get("relatorio5"),
            valores: map(
              snapshot.get("relatorio5.valores"),
              (v) =>
                ({
                  ...v,
                  dataBase: moment(v.dataBase.toDate()),
                } as RelatorioRendaVariavel)
            ),
          },
        }),
      toFirestore: toFirestore,
    };
  }
}
